import { EditOutlined } from "@ant-design/icons";
import { useMetricPerformanceContext } from "@src/contexts/ab-testing/metric-performance-context";
import { ChartFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { Form, InputNumber, InputNumberProps, Popover, Slider } from "antd";
import { FormInstance } from "antd/lib/form";
import React from "react";

export const SignificanceLevel: React.FC<{
    targetKey?: string;
    form?: FormInstance<any>;
    fieldName?: string;
    _onChange?: (value: any) => void;
}> = ({ targetKey, form, fieldName = ChartFormFieldsEnum.METRIC_SIGNIFICANCE_LEVEL, _onChange }) => {
    const { form: formContext, handleUpdateMetricTabItems } = useMetricPerformanceContext();
    const _form = form ?? formContext;
    const _fieldName = targetKey ? [targetKey, fieldName] : fieldName;
    const inputValue = Form.useWatch(_fieldName, _form);

    const onChange: InputNumberProps["onChange"] = (value) => {
        if (Number.isNaN(value)) {
            return;
        }
        value && _onChange?.(value);
        const _value = Math.round(Number(value) * 100) / 100;
        _form.setFieldValue(_fieldName, _value);
        targetKey && handleUpdateMetricTabItems(targetKey, fieldName);
    };

    return (
        <div>
            <Form.Item label="Significance level">
                <div className="flex">
                    <span>{inputValue}</span>
                    <Popover
                        trigger="click"
                        content={
                            <div className="">
                                <span className="text-black">Significance Level</span>
                                <div className="w-[400px] flex justify-start">
                                    <Slider
                                        style={{ width: 300 }}
                                        min={0.01}
                                        max={0.2}
                                        onChange={onChange}
                                        value={typeof inputValue === "number" ? inputValue : 0}
                                        step={0.01}
                                    />
                                    <InputNumber
                                        min={0.01}
                                        max={0.2}
                                        style={{ margin: "0 16px" }}
                                        step={0.01}
                                        value={inputValue}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        }
                    >
                        <EditOutlined className="text-blue-500 ml-2 canEdit" />
                    </Popover>
                </div>
            </Form.Item>
            <Form.Item name={_fieldName} hidden>
                <InputNumber min={0.01} max={0.2} step={0.01} />
            </Form.Item>
        </div>
    );
};

export const SignificanceLevelMemo = React.memo(SignificanceLevel);
